// 炉子加热工单（sith-mes-server /sithMesTpmOpcCurveQuery）：新增 / 修改 / 查看 / 删除，项目号 / 工单号 / 工序号联想（导出 PDF 弹窗复用联想）。
// base url 用 VUE_APP_SITHMES_PRD_URL 而不是 VUE_APP_SITHMES_TPM_URL：二者都指向 sith-mes，但 TPM_URL
// 在 .env.development.bypassGateway / byGateway 等多份 env 里没有定义（本地联调与 preview 都从 bypassGateway 复制）。
// 返回值约定（memory mmf-api-response-unwrap）：api/get resolve body；api/post resolve 完整 axios response；api/delete resolve body。

function baseUrl() {
    return process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesTpmOpcCurveQuery';
}

function query(params) {
    return Object.keys(params)
        .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
}

/** 工单号前缀联想 → [{orderCode, projectCode, materialCode}]；projectCode 非空时只要该项目下的工单 */
export function fetchOrderSuggest(store, keyword, projectCode) {
    return store.dispatch('api/get', {
        url: baseUrl() + '/orderSuggest?' + query({keyword, projectCode})
    }).then(list => (Array.isArray(list) ? list : []));
}

/** 项目号前缀联想 → [projectCode]（keyword trim 后至少 2 位，至多 20 条） */
export function fetchProjectSuggest(store, keyword) {
    return store.dispatch('api/get', {
        url: baseUrl() + '/projectSuggest?' + query({keyword})
    }).then(list => (Array.isArray(list) ? list : []));
}

/** 工单的工序号 → [operationSeq]（升序去重） */
export function fetchOperations(store, orderCode) {
    return store.dispatch('api/get', {
        url: baseUrl() + '/operations?' + query({orderCode})
    }).then(list => (Array.isArray(list) ? list : []));
}

/** 工单的项目号 / 物料编码 → {orderCode, projectCode, materialCode}；工单不存在时后端 400，由调用方处理（不走全局提示） */
export function fetchOrderInfo(store, orderCode) {
    return store.dispatch('api/get', {
        url: baseUrl() + '/orderInfo?' + query({orderCode}),
        commonErrorHandle: false
    });
}

/**
 * 新增 / 修改炉子加热工单。不走全局错误提示：400 / 409 的 body 是 {code, message}，由调用方处理，
 * 其它错误调用方再 dispatch('api/error')。resolve 保存后的 VO。
 * form 的时间用 toApiTime（yyyy-MM-dd HH:mm:ss）。
 */
export function createRecord(store, form) {
    return store.dispatch('api/post', {
        url: baseUrl() + '/create',
        data: form,
        commonErrorHandle: false,
        consoleLog: false
    }).then(response => response && response.data);
}

// api/put 的参数名是 entity，且 resolve 的是 body（不同于 api/post 的完整 response）
export function updateRecord(store, form) {
    return store.dispatch('api/put', {
        url: baseUrl() + '/update',
        entity: form,
        commonErrorHandle: false
    });
}

/** 一条记录（曲线页按 recordId 加载）；404 由调用方提示 */
export function fetchRecord(store, id) {
    return store.dispatch('api/get', {
        url: baseUrl() + '/detail?' + query({id}),
        commonErrorHandle: false
    });
}

/** 删除一条记录（不存在视为已删除） */
export function deleteRecord(store, id) {
    return store.dispatch('api/delete', {
        url: baseUrl() + '/deleteOne?' + query({id})
    });
}

/** 后端 400 / 409 返回的 {code, message} 里的给用户看的文案；不是这两类返回 null */
export function userMessageOf(error, status) {
    const response = error && error.response;
    if (response && response.status === status && response.data && response.data.message) {
        return response.data.message;
    }
    return null;
}
